<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Kid on That Corner</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#chapter-1-clarity">Chapter 1: Clarity</a></li>
<li id="toc-li-4"><span href="#/text/ch004#chapter-2-secure" title="Link target outside of Sample">Chapter 2: Secure</span></li>
<li id="toc-li-5"><span href="#/text/ch005#chapter-3-separate" title="Link target outside of Sample">Chapter 3: Separate</span></li>
<li id="toc-li-6"><span href="#/text/ch006#chapter-4-dispatch" title="Link target outside of Sample">Chapter 4: Dispatch</span></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-5-tied" title="Link target outside of Sample">Chapter 5: Tied</span></li>
<li id="toc-li-9"><span href="#/text/ch008#what-does-a-candle-represent" title="Link target outside of Sample">What Does a Candle Represent?</span></li>
<li id="toc-li-10"><span href="#/text/ch009#what-it-means-to-chase-the-bag-ybc" title="Link target outside of Sample">What It Means to Chase the Bag? (YBC)</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?1d383f63